import CurrentWebsiteIDProvider from './CurrentWebsiteIDProvider'

export default CurrentWebsiteIDProvider

export { useCurrentWebsiteID } from './currentWebsiteIDContext'
